<template>
  <!-- {{ page }}
  {{ perPage }}
  {{ total }} -->
  <div class="flex justify-end">
    <UPagination v-model="page" :page-count="perPage" :total="total" :max="max || 10" />
  </div>
</template>
<script lang="ts" setup>
import { useVModels, useWindowSize } from '@vueuse/core';

type Props = {
  page: number;
  perPage: number;
  total: number;
  max?: number;
};
const props = withDefaults(defineProps<Props>(), {
  page: 1,
  perPage: 50,
  total: 0,
});
const emit = defineEmits(['update:page', 'update:per-page', 'update:total']);
const { page, perPage, total } = useVModels(props, emit);

const { width } = useWindowSize();
</script>
